import { DOCUMENT_REASON } from "../common/Constants";

export default function FormatDocReasonText(text, props) {
  if (text) {
    const formatDocumentReason =
      text.documentReason &&
      text.documentReason.split(",").map((item) => {
        return ` ${props.t(
          "FinanceLeaseNotifications." + DOCUMENT_REASON[item]
        )} `;
      });
    return formatDocumentReason.toString().replace(/,/g, "/");
  } else return "";
}
